// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"S4wpOmhwbsKc9n6LX2D_T","secondRowWithControls":"_3oyiO35Gjw9UpTLFhW2WDq","verticalAlignBlock":"felVsw82BgXJChb6QK7L8"};